export var FeaturesTypes;
(function (FeaturesTypes) {
    FeaturesTypes["QUOTA"] = "QuotaFeature";
    FeaturesTypes["BOOL"] = "BooleanFeature";
    FeaturesTypes["MONTHLY"] = "MonthlyQuotaFeature";
})(FeaturesTypes || (FeaturesTypes = {}));
